module.exports = __webpack_public_path__ + "img/3.416995eb.png";